<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M8 11C8.28333 11 8.521 10.904 8.713 10.712C8.905 10.52 9.00067 10.2827 9 10C9 9.71667 8.904 9.479 8.712 9.287C8.52 9.095 8.28267 8.99934 8 9C7.71667 9 7.479 9.096 7.287 9.288C7.095 9.48 6.99933 9.71734 7 10C7 10.2833 7.096 10.521 7.288 10.713C7.48 10.905 7.71733 11.0007 8 11ZM12 11C12.2833 11 12.521 10.904 12.713 10.712C12.905 10.52 13.0007 10.2827 13 10C13 9.71667 12.904 9.479 12.712 9.287C12.52 9.095 12.2827 8.99934 12 9C11.7167 9 11.479 9.096 11.287 9.288C11.095 9.48 10.9993 9.71734 11 10C11 10.2833 11.096 10.521 11.288 10.713C11.48 10.905 11.7173 11.0007 12 11ZM16 11C16.2833 11 16.521 10.904 16.713 10.712C16.905 10.52 17.0007 10.2827 17 10C17 9.71667 16.904 9.479 16.712 9.287C16.52 9.095 16.2827 8.99934 16 9C15.7167 9 15.479 9.096 15.287 9.288C15.095 9.48 14.9993 9.71734 15 10C15 10.2833 15.096 10.521 15.288 10.713C15.48 10.905 15.7173 11.0007 16 11ZM2 22V4C2 3.45 2.196 2.979 2.588 2.587C2.98 2.195 3.45067 1.99934 4 2H20C20.55 2 21.021 2.196 21.413 2.588C21.805 2.98 22.0007 3.45067 22 4V16C22 16.55 21.804 17.021 21.412 17.413C21.02 17.805 20.5493 18.0007 20 18H6L2 22ZM5.15 16H20V4H4V17.125L5.15 16Z"
      fill="#213E7A"
    />
  </svg>
</template>

<script>
export default {
  name: "IconSMSBalance",
};
</script>

<style></style>
